import { PH_MOBILE_NUMBER_LENGTH } from '@back-office/ui';
import Joi from 'joi';
import { InviteNewUserFieldNames } from './invitation.form';

export enum LoginFieldNames {
  Email = 'email',
  Password = 'password',
}

export enum ForgotPasswordFieldNames {
  Email = 'email',
}

export interface LoginForm {
  [LoginFieldNames.Email]: string;
  [LoginFieldNames.Password]: string;
}

export interface ForgotPasswordForm {
  [ForgotPasswordFieldNames.Email]: string;
}

// Login Form
export const loginSchema = Joi.object({
  [LoginFieldNames.Email]: Joi.string().required(),
  [LoginFieldNames.Password]: Joi.string().required(),
});

export const emailValidator = Joi.string().email({
  tlds: { allow: false },
});
// Forgot Password Form
export const forgotPasswordSchema = Joi.object({
  email: Joi.string().email({ tlds: { allow: false } }),
});
// Invite New User Form
export const emailSchema = Joi.object({
  [InviteNewUserFieldNames.Email]: emailValidator,
  [InviteNewUserFieldNames.Phone]: Joi.string()
    .pattern(new RegExp(`^[0-9]{${PH_MOBILE_NUMBER_LENGTH}}$`))
    .required(),
});

export enum LoginStep {
  Login = 'login',
  ForgotPassword = 'forgot_password',
  SelectMerchant = 'select_merchant',
  CheckEmail = 'check_email',
  EnterOTP = 'enter_otp',
}
